<!doctype html>
<html lang="en-US" dir="ltr" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <title></title>
  <!--[if !mso]><!-->
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <!--<![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    #outlook a {
      padding: 0;
    }

    body {
      margin: 0;
      padding: 0;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    }

    table, td {
      border-collapse: collapse;
      mso-table-lspace: 0pt;
      mso-table-rspace: 0pt;
    }

    img {
      border: 0;
      height: auto;
      line-height: 100%;
      outline: none;
      text-decoration: none;
      -ms-interpolation-mode: bicubic;
    }

    p {
      display: block;
      margin: 13px 0;
    }
  </style>
  <!--[if mso]>
  <noscript>
  <xml>
  <o:OfficeDocumentSettings>
    <o:AllowPNG/>
    <o:PixelsPerInch>96</o:PixelsPerInch>
  </o:OfficeDocumentSettings>
  </xml>
  </noscript>
  <![endif]-->
  <!--[if lte mso 11]>
  <style type="text/css">
    .mj-outlook-group-fix { width:100% !important; }
  </style>
  <![endif]-->


  <style type="text/css">
    @media only screen and (min-width:480px) {
      .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%;
      }

      .mj-column-per-75 {
        width: 75% !important;
        max-width: 75%;
      }

      .mj-column-per-25 {
        width: 25% !important;
        max-width: 25%;
      }

      .mj-column-per-50 {
        width: 50% !important;
        max-width: 50%;
      }
    }
  </style>
  <style media="screen and (min-width:480px)">
    .moz-text-html .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }

    .moz-text-html .mj-column-per-75 {
      width: 75% !important;
      max-width: 75%;
    }

    .moz-text-html .mj-column-per-25 {
      width: 25% !important;
      max-width: 25%;
    }

    .moz-text-html .mj-column-per-50 {
      width: 50% !important;
      max-width: 50%;
    }
  </style>
  <style type="text/css">
    [owa] .mj-column-per-100 {
      width: 100% !important;
      max-width: 100%;
    }

    [owa] .mj-column-per-75 {
      width: 75% !important;
      max-width: 75%;
    }

    [owa] .mj-column-per-25 {
      width: 25% !important;
      max-width: 25%;
    }

    [owa] .mj-column-per-50 {
      width: 50% !important;
      max-width: 50%;
    }
  </style>

  <style type="text/css">
  </style>
  <style type="text/css">
  </style>

</head>
<body style="word-spacing:normal;background-color:transparent;">


  <div style="background-color:transparent;" role="main" lang="en-US" dir="ltr">


    <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:bottom;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:0px 25px 0px 25px;padding-top:0px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;letter-spacing:normal;line-height:1;text-align:left;color:#000000;"><p class="text-build-content" style="text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px">To read this email in a browser </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.email.googleassistantprivacylitigation.com/email-en"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:11px"><u>click here</u></span></a><br><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.email.googleassistantprivacylitigation.com/email-en"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px">Para leer este correo electrónico en un navegador, </span></a><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.email.googleassistantprivacylitigation.com/email-sp"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:11px"><u>haga clic aquí</u></span></a></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:bottom;width:450px;" ><![endif]-->

              <div class="mj-column-per-75 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:0px 0px 0px 0px;padding-top:0px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;letter-spacing:normal;line-height:1;text-align:left;color:#000000;"><p class="text-build-content" style="text-align: right; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Share This Settlement</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td><td class="" style="vertical-align:bottom;width:150px;" ><![endif]-->

              <div class="mj-column-per-25 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:bottom;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:bottom;" width="100%">
                  <tbody>

                    <tr>
                      <td align="right" style="font-size:0px;padding:0px 0px 5px 0px;word-break:break-word;">


                        <!--[if mso | IE]><table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" ><tr><td><![endif]-->
                        <table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>

                            <tr>

                              <td aria-hidden="true" style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#3B5998;border-radius:3px;width:25px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:25px;vertical-align:middle;width:25px;">
                                        <a href="http://www.facebook.com/share.php?u=https%3A%2F%2Fwww.googleassistantprivacylitigation.com" target="_blank">
                                          <img alt="Share this Settlement on Facebook" height="25" src="https://static.mailjet.com/ico-social/facebook.png" style="border-radius:3px;display:block;" width="25" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>



                            </tr>

                          </tbody>
                        </table>
                        <!--[if mso | IE]></td><td><![endif]-->
                        <table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>

                            <tr>

                              <td aria-hidden="true" style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0077B5;border-radius:3px;width:25px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:25px;vertical-align:middle;width:25px;">
                                        <a href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.googleassistantprivacylitigation.com" target="_blank">
                                          <img alt="Share this Settlement on LinkedIn" height="25" src="https://static.mailjet.com/ico-social/linkedin.png" style="border-radius:3px;display:block;" width="25" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>



                            </tr>

                          </tbody>
                        </table>
                        <!--[if mso | IE]></td><td><![endif]-->
                        <table align="right" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>

                            <tr>

                              <td aria-hidden="true" style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0F141A;border-radius:3px;width:25px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:25px;vertical-align:middle;width:25px;">
                                        <a href="https://twitter.com/intent/tweet?text=Did%20you%20buy%20a%20Google-Made%20Device%20that%20uses%20the%20Google%20Assistant%3F%20Or%20did%20the%20Google%20Assistant%20record%20your%20private%20conversations%3F%20You%20could%20be%20eligible%20for%20money%20from%20a%20%2468%20million%20settlement.%20Learn%20more%20at%20www.GoogleAssistantPrivacyLitigation.com." target="_blank">
                                          <img alt="Share this Settlement on X (Twitter)" height="25" src="https://static.mailjet.com/ico-social/twitter-x.png" style="border-radius:3px;display:block;" width="25" />
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>



                            </tr>

                          </tbody>
                        </table>
                        <!--[if mso | IE]></td></tr></table><![endif]-->


                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="border:1px solid #1869d4;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:598px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px 10px 25px;padding-top:10px;padding-bottom:10px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:20px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><h1 class="text-build-content" style="margin-top: 10px"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:20px"><b>Google Assistant Privacy Litigation Settlement</b></span></h1><p class="text-build-content" style="margin: 10px 0;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:16px">Did you purchase a Google-Made Device or were your communications recorded by Google Assistant as a result of a False Accept or disclosed to a third-party review vendor?</span></p><p class="text-build-content" style="margin: 10px 0; margin-bottom: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:16px">You could be eligible for money&nbsp;</span><br><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:16px">from a $68 million class action Settlement</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="border:1px solid #1869d4;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:middle;width:299px;" ><![endif]-->

              <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 25px 10px 25px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com/faq" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px 10px 25px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:14px;"><b>Learn More</b></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td><td class="" style="vertical-align:middle;width:299px;" ><![endif]-->

              <div class="mj-column-per-50 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 25px 10px 25px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com\login" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 25px 10px 25px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;"><b>File a Claim</b></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="border:1px solid #1869d4;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:598px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 0px 25px;padding-top:5px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:11px">A COURT DIRECTED THIS NOTICE</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">You may qualify to get a payment from a Settlement with Defendants Google LLC and Alphabet Inc. (“Google”) in a class action lawsuit. The lawsuit claims Google violated the law and its own privacy policies with respect to the operation of Google Assistant. Google denies all of the allegations made in the lawsuit and that it did anything improper or unlawful. The Court has not made any determination as to who is right or whether Google did anything wrong. The United States District Court for the Northern District of California approved this notice.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height:20px;text-align:center;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px;"><strong>PLEASE REVIEW THE </strong></span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/notice"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:11px;"><strong>LONG-FORM NOTICE</strong></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px;"><strong> LOCATED ON THE SETTLEMENT WEBSITE,</strong></span><br><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:14px;"><strong>WWW.GOOGLEASSISTANTPRIVACYLITIGATION.COM</strong></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px;"><strong>,</strong></span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:11px;"><strong>FOR MORE DETAILED INFORMATION ABOUT THE SETTLEMENT.</strong></span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:#edf6fc;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px"><b>Am I included in the Settlement?</b></span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px"><i><b>You are a member of the Purchaser Settlement Clas</b></i><b>s if you </b>are a User who purchased a Google-Made Device in the United States or its territories between May 18, 2016, and March 19, 2026.</span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px"><i><b>You are a member of the Privacy Settlement Class</b></i><b> if you </b>are a User of Google Assistant or were a member of a User’s Household between May 18, 2016, and March 19, 2026, and your communications were recorded or otherwise obtained by Google Assistant as a result of a False Accept or disclosed to any third-party review vendor.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><ul><li style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">"Users" are individuals who reside in the United States or its territories whose Google accounts were associated with at least one Google Assistant Enabled Device during the Class Period;</span><br>&nbsp;</li><li style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">"Household" is a group of individuals sharing a common abode;</span><br>&nbsp;</li><li style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">"Google Assistant Enabled Devices" are devices that come with Google Assistant pre-installed or on which Google Assistant can be downloaded;</span><br>&nbsp;</li><li style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">"Google-Made Devices" are Google Assistant Enabled Devices manufactured and sold by Google either directly or through third-party retailers, including Google’s own smart home speakers (Google Home, Home Mini, and Home Max); smart displays (Google Nest Hub and Nest Hub Max); and Pixel smartphones;</span><br>&nbsp;</li><li style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">"False Accept" is an instance where a Google Assistant Enabled Device records and transmits audio data to Google’s servers because a Hot Word was detected although a Hot Word was not spoken; and</span><br>&nbsp;</li><li style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">"Hot Word" is a word or phrase (such as "OK Google" or "Hey Google") which can be used to activate Google Assistant on certain Google Assistant Enabled Devices.</span></li></ul></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">Certain people are excluded from the Settlement Classes. The list of excluded individuals is available </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>HERE</strong></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">.</span></p><p class="text-build-content" style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">If you are a member of one or both of the Settlement Classes, then you are eligible under the terms of the Settlement to submit a Claim Form to receive a payment if the Court approves the Settlement and it becomes final. You are not necessarily a member of either or both Settlement Classes simply because you received this notice; you could be a member of one (or none) of the Settlement Classes. Please read each definition carefully and refer to the additional information on the Settlement Website, </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>www.GoogleAssistantPrivacyLitigation.com</strong></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">, to determine whether you are a member of either or both Settlement Classes.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#edf6fc" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#edf6fc;background-color:#edf6fc;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#edf6fc;background-color:#edf6fc;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:middle;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height:20px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px;"><strong>What does the Settlement provide?</strong></span></p><p class="text-build-content" style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">If you are a member of one or both of the Settlement Classes, then you are eligible under the terms of the Settlement to submit a Claim Form to receive a payment if the Court approves the Settlement and it becomes final.</span></p><p class="text-build-content" style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">You are not necessarily a member of either or both Settlement Classes simply because you received this notice; you could be a member of one (or none) of the Settlement Classes. Please read each definition carefully and refer to the additional information on the Settlement Website, </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>www.GoogleAssistantPrivacyLitigation.com</strong></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">, to determine whether you are a member of either or both Settlement Classes.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height:20px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px;"><strong>What are the expected payments?</strong></span></p><p class="text-build-content" style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">At this time, it is unknown how much each Settlement Class Member who files a valid claim will receive. Money will be paid proportionally to eligible Settlement Class Members according to the proposed Plan of Allocation, which can be found </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/court-documents"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>HERE</strong></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height:20px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px;"><strong>How do I file a Claim?</strong></span></p><p class="text-build-content" style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">To receive a payment, you must complete and timely submit a valid Claim Form by August 27, 2026. You may complete and submit an electronic Claim Form online at the Settlement Website, </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>www.GoogleAssistantPrivacyLitigation.com</strong></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">, or by mail to the address on the Claim Form postmarked by August 27, 2026. You can get a Claim Form at the Settlement Website or by calling 1-877-411-4704.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="center" vertical-align="middle" style="background:transparent;font-size:0px;padding:0px 25px 10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 15px 10px 15px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com/login" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 15px 10px 15px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:14px;"><b>FILE NOW</b></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">Claim Forms should be submitted individually by each Settling Class Member and not a third party, except for parents/guardians submitting a Claim Form on behalf of a minor Settling Class Member. Claim Forms submitted <i>en masse</i> will be rejected. The Claim Form requires that you confirm or update your current contact information and confirm under oath that you are a member of one of both of the Settlement Classes.</span></p><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">If you do not complete and submit a valid Claim Form, you will not receive a payment.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:middle;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:middle;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:middle;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height:20px;"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:16px;"><strong>What are my rights?</strong></span></p><p class="text-build-content" style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">If you are included in the Settlement and you do nothing, your rights will be affected, and you won’t get a payment. If you previously timely submitted a request for exclusion from the previously certified purchaser class, you remain opted out of this Settlement unless you choose to opt back in, such as by filing a Claim Form by <strong>August 27, 2026</strong>. If you want to keep your right to sue or continue to sue Google for the claims in this case and don’t want to be legally bound by the Court’s decisions, and you did not exclude yourself from the previously certified purchaser class by the deadline of <strong>September 9, 2024</strong>, you must exclude yourself from the Settlement by <strong>August 27, 2026</strong>. If you stay in the Settlement (i.e., do not exclude yourself), you may object to it, the Plan of Allocation, or the request for attorneys’ fees and expenses and service awards by <strong>August 27, 2026</strong>. A copy of Class Counsel’s Motion for an Attorneys’ Fees and Expense Award and for Plaintiffs’ Service Awards will be available at </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/faq"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>www.GoogleAssistantPrivacyLitigation.com</strong></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;"> within three business days after filing the motion with the Court on <strong>July 23, 2026</strong>.</span></p><p class="text-build-content" style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">The Court will hold a Final Approval Hearing on <strong>October 1, 2026</strong>, to consider if it will approve the Settlement and a request for attorneys’ fees up to one-third of the Settlement Fund, expenses up to $1,600,000, and service awards up to $10,000 for each named Plaintiff. The hearing will be held on <strong>October 1, 2026, at 9:00 a.m. PT</strong>, at the United States District Court for the Northern District of California, San Jose Courthouse, 280 South 1st Street, Courtroom 1 – 5th Floor, San Jose, CA 95113.</span></p><p class="text-build-content" style="line-height:20px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">You may ask for permission for you or your own lawyer to appear and speak at the Final Approval Hearing – at your own cost – <strong>but you do not have to do so</strong>.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#edf6fc" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#edf6fc;background-color:#edf6fc;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#edf6fc;background-color:#edf6fc;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="background:transparent;font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height:20px;text-align:center;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>PLEASE REVIEW THE</strong></span><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong> </strong></span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/notice"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>LONG-FORM NOTICE</strong></span></a><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>&nbsp;</strong></span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>LOCATED ON THE SETTLEMENT WEBSITE,</strong></span><br><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://www.GoogleAssistantPrivacyLitigation.com/FAQ"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;"><strong>www.GoogleAssistantPrivacyLitigation.com</strong></span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">,</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">for more detailed information about the Settlement,</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">or you may contact the Claims Administrator with any questions:</span></p><p class="text-build-content" style="line-height:20px;text-align:center;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">Google Assistant Privacy Settlement</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">c/o A.B. Data, Ltd.</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">P.O. Box 170500</span><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">Milwaukee, WI 53217</span><br><a class="link-build-content" style="color:inherit;text-decoration:none;" href="mailto:info@GoogleAssistantPrivacyLitigation.com"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px;">info@GoogleAssistantPrivacyLitigation.com</span></a><br><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px;">Toll-free: 1-877-411-4704</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="center" vertical-align="middle" style="font-size:0px;padding:0px 25px 10px 25px;word-break:break-word;">

                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:separate;line-height:100%;">
                          <tbody>
                            <tr>
                              <td align="center" bgcolor="#cbe6f6" role="presentation" style="border:none;border-radius:50px;cursor:auto;mso-padding-alt:10px 15px 10px 15px;background:#cbe6f6;" valign="middle">
                                <a href="https://www.GoogleAssistantPrivacyLitigation.com/login" style="display:inline-block;background:#cbe6f6;color:#1869d4;font-family:Verdana, Helvetica, Arial, sans-serif;font-size:14px;font-weight:normal;line-height:120%;margin:0;text-decoration:none;text-transform:none;padding:10px 15px 10px 15px;mso-padding-alt:0px;border-radius:50px;" target="_blank">
                                  <span style="background-color:transparent;color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:14px;"><b>FILE A CLAIM</b></span>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#ffffff" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-top:0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 5px 25px;padding-top:5px;padding-bottom:5px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">You may also access the docket in this case through the Court’s Public Access to Court Electronic Records (PACER) system at </span><a class="link-build-content" style="color:inherit;text-decoration:none;" target="_blank" href="https://ecf.cand.uscourts.gov"><span style="color:#1869d4;font-family:Verdana, Arial, sans-serif;font-size:13px">https://ecf.cand.uscourts.gov</span></a><span style="color:#000000;font-family:Verdana, Arial, sans-serif;font-size:13px">, or by visiting the office of the Clerk of the Court for the United States District Court for the Northern District of California at any of the Court’s locations between 9:00 a.m. and 4:00 p.m., Monday through Friday, excluding Court holidays.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" role="presentation" style="width:600px;" width="600" bgcolor="#1869d4" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->


    <div style="background:#1869d4;background-color:#1869d4;margin:0px auto;max-width:600px;">

      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#1869d4;background-color:#1869d4;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0px 0px 0px 0px;text-align:center;">
              <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->

              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">

                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 0px 25px;padding-top:5px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:16px">PLEASE DO NOT CALL THE COURT OR THE COURT CLERK’S OFFICE TO INQUIRE ABOUT THIS SETTLEMENT.</span></p></div>

                      </td>
                    </tr>

                    <tr>
                      <td align="left" style="font-size:0px;padding:5px 25px 0px 25px;padding-top:5px;padding-bottom:0px;word-break:break-word;">

                        <div style="font-family:Verdana, Helvetica, Arial, sans-serif;font-size:13px;letter-spacing:normal;line-height:1;text-align:left;color:#55575d;"><p class="text-build-content" style="line-height: 20px; text-align: center; margin: 10px 0; margin-top: 10px; margin-bottom: 10px;"><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:13px">BY ORDER OF THE U.S. DISTRICT COURT</span><br><span style="color:#ffffff;font-family:Verdana, Arial, sans-serif;font-size:13px">FOR THE NORTHERN DISTRICT OF CALIFORNIA.</span></p></div>

                      </td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!--[if mso | IE]></td></tr></table><![endif]-->


  </div>

</body>
</html>
